import { withStyles } from "@material-ui/core"

// Global CSS
const GlobalCss = withStyles(theme => ({
  "@global": {
    html: {
      scrollBehavior: "smooth"
    },
    a: {
      textDecoration: "none",
      color: "inherit"
    },
    ".img-fluid": {
      width: "100%",
      height: "100%"
    },

    // Text
    ".text-regular": {
      fontWeight: `${theme.typography.fontWeightRegular} !important`
    },
    ".text-medium": {
      fontWeight: `${theme.typography.fontWeightMedium} !important`
    },
    ".text-bold": {
      fontWeight: `${theme.typography.fontWeightBold} !important`
    },
    ".text-bolder": {
      fontWeight: `${theme.typography.fontWeightBolder} !important`
    },
    ".text-capitalize": {
      textTransform: "capitalize"
    },
    ".text-success": {
      color: theme.palette.success.main
    },
    ".text-error": {
      color: theme.palette.error.main
    },
    ".text-primary": {
      color: theme.palette.primary.main
    },

    // Flex
    ".flex": {
      display: "flex"
    },
    ".flex-col": {
      flexDirection: "column"
    },
    ".align-items-center": {
      alignItems: "center"
    },
    ".justify-center": {
      justifyContent: "center"
    },
    ".justify-space-between": {
      justifyContent: "space-between"
    },

    // Common
    ".paper": {
      padding: theme.spacing(3)
    },

    ".cursor-pointer": {
      cursor: "pointer"
    },
    ".h-100": {
      height: "100%"
    },

    // Teacher Testimonial Card
    // Reference: https://www.labnol.org/internet/light-youtube-embeds/27941/
    ".youtube-player": {
      position: "relative",
      paddingBottom: "56.25%",
      height: "0",
      overflow: "hidden",
      maxWidth: "100%",
      background: "#000",
      margin: "5px"
    },
    ".youtube-player iframe": {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      zIndex: 100,
      background: "transparent"
    },
    ".youtube-player img": {
      objectFit: "cover",
      display: "block",
      left: "0",
      bottom: "0",
      margin: "auto",
      maxWidth: "100%",
      width: "100%",
      position: "absolute",
      right: "0",
      top: "0",
      border: "none",
      height: "auto",
      cursor: "pointer",
      WebkitTransition: "0.4s all",
      MozTransition: "0.4s all",
      transition: "0.4s all"
    },
    ".youtube-player img:hover": { WebkitFilter: "brightness(75%)" },
    ".youtube-player .play": {
      height: "72px",
      width: "72px",
      left: "50%",
      top: "50%",
      marginLeft: "-36px",
      marginTop: "-36px",
      position: "absolute",
      background: "url('//i.imgur.com/TxzC70f.png') no-repeat",
      cursor: "pointer"
    }
  }
}))(() => null)

export default GlobalCss
